import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { FormHelper } from 'src/app/base/shared/form-helper';
import { TranslateModule } from '@ngx-translate/core';
import { YesNoGroupButtonComponent } from '../../../../base/shared/yes-no-group-button/yes-no-group-button.component';

import { AppErrorMessagesComponent } from '../../../../base/error-messages/app-error-messages.component';

@Component({
    selector: 'app-company-form',
    templateUrl: './company-form.component.html',
    styleUrls: ['./company-form.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, YesNoGroupButtonComponent, TranslateModule]
})
export class CompanyFormComponent implements OnInit {
  @Input()
  public companyForm: FormGroup;

  public isAdd = true;

  public get formFields() {
    return this.companyForm?.controls;
  }

  constructor() { }

  ngOnInit() {
    this.isAdd = !this.companyForm.value.id;
    FormHelper.setFieldDisabledStatus(this.companyForm.controls.active, !this.isAdd);
  }

}
